module.exports = __webpack_public_path__ + "img/zichan_bg@2x.765abc25.png";